// extracted by mini-css-extract-plugin
export default {"main_photo":"mainPhoto_main_photo__7O148","main_title":"mainPhoto_main_title__AUzh9"};